import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProgramaService {
  token: string = '';
  baseUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) {
    this.token = environment.token;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }

  getPrograma(): Observable<any> {
    return this.http.get(this.baseUrl + 'parProgramas', { headers: this.header(this.token) });
  }

  getProgramaActivo(): Observable<any> {
    return this.http.get(this.baseUrl + 'parProgramasActivos', { headers: this.header(this.token) });
  }

  getProgramaById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'parPrograma/' + id, { headers: this.header(this.token) });
  }

  postPrograma(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'parPrograma', bodyString, { headers: this.header(this.token) });
  }

  putPrograma(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'parPrograma', bodyString, { headers: this.header(this.token) });
  }

  deletePrograma(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'parPrograma/' + id, { headers: this.header(this.token) });
  }
}
